import { render, staticRenderFns } from "./kNumber.vue?vue&type=template&id=072192c4"
import script from "./kNumber.vue?vue&type=script&lang=js"
export * from "./kNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports